import React from 'react';
import { colors } from '../../styles/constants';

interface GridProps {
    stroke?: string;
}

const Grid = (props: GridProps) => {
    const stroke = props.stroke || colors.primary;

    return (
        <svg height="16" width="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <g fill={stroke} stroke={stroke} strokeWidth="1">
                <rect height="3" width="3" fill="none" stroke={stroke} strokeLinecap="round" x="0.5" y="0.5" />
                <rect height="3" width="3" fill="none" stroke={stroke} strokeLinecap="round" x="6.5" y="0.5" />
                <rect height="3" width="3" fill="none" strokeLinecap="round" x="12.5" y="0.5" />
                <rect height="3" width="3" fill="none" stroke={stroke} strokeLinecap="round" x="0.5" y="6.5" />
                <rect height="3" width="3" fill="none" strokeLinecap="round" x="6.5" y="6.5" />
                <rect height="3" width="3" fill="none" stroke={stroke} strokeLinecap="round" x="12.5" y="6.5" />
                <rect height="3" width="3" fill="none" strokeLinecap="round" x="0.5" y="12.5" />
                <rect height="3" width="3" fill="none" stroke={stroke} strokeLinecap="round" x="6.5" y="12.5" />
                <rect height="3" width="3" fill="none" stroke={stroke} strokeLinecap="round" x="12.5" y="12.5" />
            </g>
        </svg>
    );
};

export default Grid;
